<template>
  <div>
    <div class="page-header header-filter bg-1">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="centre">{{ playerName }}</h1>
            <h5 class="centre">Enlisted: {{ playerCreatedAt }}</h5>
            <b-img
              fluid
              width="200"
              center
              src="/assets/img/Velios_Icon_White_Sm.png"
            />
          </b-col>
          <!-- <b-col cols="3" md="2" align-self="center">
            <b-img v-if="playerName == 'Duncan A'" fluid src="/assets/img/duncan.jpg" class="img-circle img-raised"/>
            <b-avatar v-else variant="light" size="lg"></b-avatar>
          </b-col> -->
        </b-row>
        <b-row align-h="center">
          <b-col cols="6" sm="3">
            <stat-field :stat="coinTotal" sub="JAX" size="lg" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container>
        <b-row align-v="stretch">
          <b-col cols="12" sm="6">
            <b-card bg-variant="info" footer="Duration" class="text-center">
              <b-card-text>
                <h3>{{ rideDuration }}</h3>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="6" sm="3">
            <b-card
              bg-variant="danger"
              footer="Calories Burned"
              class="text-center"
            >
              <b-card-text>
                <h3>{{ calTotal }}</h3>
              </b-card-text>
            </b-card>
          </b-col>
          <!-- <b-col cols="6" sm="3">
            <b-card
              bg-variant="primary"
              footer="KM"
              class="text-center">
              <b-card-text>
                <h3>{{ coinTotal }}</h3>
              </b-card-text>
            </b-card>
          </b-col> -->
          <b-col cols="6" sm="3">
            <b-card bg-variant="dark" footer="Missions" class="text-center">
              <b-card-text>
                <h3>{{ effortTotalStr }}</h3>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h1 style="margin-bottom: 48px">MISSION BESTS</h1>
          </b-col>
        </b-row>
        <b-row v-if="isRanks">
          <b-col>
            <player-ranks :ranks="ranks"></player-ranks>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <p>No ranks yet</p>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h1 style="margin-bottom: 48px">ACTIVITY</h1>
          </b-col>
        </b-row>
        <b-row v-if="isActivity">
          <b-col>
            <activity-period
              class="activity-period"
              v-for="period in activityPeriods"
              :key="period.id"
              :period="period"
            ></activity-period>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <p>No activity yet</p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { BCard, BCardText, BImg } from "bootstrap-vue";
import utils from "../utils";
import ActivityPeriod from "../components/ActivityPeriod";
import StatField from "../components/StatField.vue";
import PlayerRanks from "../components/PlayerRanks";

const { mapState, mapActions } = createNamespacedHelpers("playerProfile");

export default {
  name: "PlayerProfile",
  props: ["id"],
  components: { BCard, BCardText, BImg, ActivityPeriod, StatField, PlayerRanks },
  async created() {
    await this.loadPlayerProfile(this.id);
  },
  computed: {
    ...mapState({
      player: "player",
      activityPeriods: "activityPeriods",
      ranks: "ranks",
      playerName: (state) => state.player && state.player.name,
      playerCreatedAt: (state) =>
        state.player && utils.strToDateLocale(state.player.createdAt),
      starTotal: (state) => (state.player && state.player.starTotal) || 0,
      effortTotal: (state) => (state.player && state.player.effortTotal) || 0,
      rideDurTotal: (state) => (state.player && state.player.rideDurTotal) || 0,
      wattHrsTotal: (state) => (state.player && state.player.wattHrsTotal) || 0,
      coinTotal: (state) => (state.player && state.player.coinTotal) || 0,
    }),
    calTotal() {
      return utils.numberToStr(utils.whToCal(this.wattHrsTotal));
    },
    effortTotalStr() {
      return utils.numberToStr(this.effortTotal);
    },
    rideDuration() {
      return utils.longDurationStrFromSecs(this.rideDurTotal);
    },
    isActivity() {
      return this.activityPeriods && this.activityPeriods[0] ? true : false;
    },
    isRanks() {
      return this.ranks && this.ranks[0] ? true : false;
    },
  },
  methods: {
    ...mapActions(["loadPlayerProfile", "clearStoreState"]),
  },
  destroyed() {
    this.clearStoreState();
  },
};
</script>

<style scoped>
.img-circle {
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid white;
}
.page-header {
  height: auto;
  padding-top: 100px;
  padding-bottom: 50px;
}
.activity-period {
  margin-bottom: 64px;
}
</style>